var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-b-container",style:(_vm.getContainerStyle)},_vm._l((_vm.getLayoutItems),function(layoutItem,index){return _c('group-item',{key:index,style:(_vm.getItemLayout(layoutItem)),attrs:{"layoutItem":layoutItem,"itemSize":_vm.getItemSize(layoutItem),"containerSize":_vm.getContainerSize,"items":_vm.getItems}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06ed0142","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/cardpage/group/CardGroupB.vue
// module id = null
// module chunks = 